import Ajv from "ajv";

const ajv = new Ajv();
const mbHealthCardSchema = {
  type: "object",
  properties: {
    firstName: { type: "string" },
    middleName: { type: "string" },
    lastName: { type: "string" },
    regNum: { type: "string" },
    phin: { type: "string" },
    dob: { type: "string" },
    lang: { type: "string" },
  },
  required: [
    "firstName",
    "middleName",
    "lastName",
    "regNum",
    "phin",
    "dob",
    "lang",
  ],
  additionalProperties: false,
};
const validator = ajv.compile(mbHealthCardSchema);

/**
 * @brief Takes a string and creates a JSON object representing the data stored on a plastic MB Health Card
 *
 * @param qrString String retrieved from a QR Code, ideally one from a MB Health Card
 *
 * @returns JSON data from MB Health Card QR Code, null if data invalid or not from an MB Health Card
 */
const processQRData = (qrString) => {
  if (!qrString) {
    return null;
  }
  let json;

  try {
    json = JSON.parse(qrString);
  } catch (error) {
    return null;
  }

  if (validator(json)) {
    return json;
  } else {
    return null;
  }
};

export default processQRData;
